import React, { useState } from "react";
import { Card, Collapse, Button } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

function CollapsibleCard({ title, icon, children, defaultExpanded = true, className = "", headerClassName = "", hideHeader = false }) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  // Embedded in something that already shows its own title (e.g. a DesktopWindow's
  // titlebar) — the collapse toggle has no home without a header, so just render the
  // content, always expanded.
  if (hideHeader) {
    return (
      <Card className={`shadow-lg ${className}`}>
        <Card.Body>{children}</Card.Body>
      </Card>
    );
  }

  return (
    <Card className={`shadow-lg ${className}`}>
      <Card.Header className={`d-flex align-items-center justify-content-between fw-bold fs-6 ${headerClassName}`}>
        <div className="d-flex align-items-center">
          {icon && <span className="me-2">{icon}</span>}
          <span>{title}</span>
        </div>
        <Button
          variant="link"
          className="p-0 border-0 text-decoration-none"
          onClick={toggleExpanded}
          style={{ color: "inherit" }}
        >
          {expanded ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
        </Button>
      </Card.Header>
      <Collapse in={expanded}>
        <div>
          <Card.Body>
            {children}
          </Card.Body>
        </div>
      </Collapse>
    </Card>
  );
}

export default CollapsibleCard;